import { useContext } from "react"

import { ApplicationStateContext, ApplicationDispatchContext } from "./ApplicationContext.context"

export const useApplicationStateContext = () => {
    const context = useContext(ApplicationStateContext)
    if (context === undefined) {
        throw new Error("useApplicationStateContext must be used within an ApplicationStateContext")
    }
    return context
}

export const useApplicationDispatchContext = () => {
    const context = useContext(ApplicationDispatchContext)
    if (context === undefined) {
        throw new Error("useApplicationDispatchContext must be used within an ApplicationDispatchContext")
    }
    return context
}

export const useApplicationContext = () => {
    return [useApplicationStateContext(), useApplicationDispatchContext()]
}
